import { Grid, Typography, makeStyles } from "@material-ui/core";
import { ITheme } from "../constants/theme";

export const Stamp = ({ text = "", type = "success" }: IStampProps) => {
  const classes = useStyles();

  let wrapperStyle;
  let textStyle;
  switch (type) {
    case "primary":
      wrapperStyle = classes.primaryBadge;
      textStyle = classes.primaryBadgeText;
      break;
    case "success":
      wrapperStyle = classes.successBadge;
      textStyle = classes.successBadgeText;
      break;
    case "warning":
      wrapperStyle = classes.warningBadge;
      textStyle = classes.warningBadgeText;
      break;
    case "fail":
      wrapperStyle = classes.failureBadge;
      textStyle = classes.failureBadgeText;
      break;
    case "refunded":
      wrapperStyle = classes.failureBadge;
      textStyle = classes.failureBadgeText;
      break;
    default:
      wrapperStyle = classes.successBadge;
      textStyle = classes.successBadgeText;
  }

  return (
    <Grid item className={classes.container}>
      <Grid className={wrapperStyle}>
        <Typography variant="caption" component="span" className={textStyle}>
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    marginLeft: 14,
    alignSelf: "center",
    whiteSpace: 'nowrap'
  },
  primaryBadge: {
    backgroundColor: "rgba(158, 0, 93, 0.16)",
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 2,
    borderRadius: 4,
  },
  primaryBadgeText: {
    color: theme.palette.primary.main,
    lineHeight: 1,
    fontWeight: 400,
  },
  failureBadge: {
    backgroundColor: "rgba(255, 75, 52, 0.16)",
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 2,
    borderRadius: 4,
  },
  failureBadgeText: {
    color: "rgba(255, 75, 52, 1)",
    lineHeight: 1,
    fontWeight: 400,
  },
  successBadge: {
    backgroundColor: "rgba(76, 175, 80, 0.16)",
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 2,
    borderRadius: 4,
  },
  successBadgeText: {
    color: "rgba(76, 175, 80, 1)",
    lineHeight: 1,
    fontWeight: 400,
  },
  warningBadge: {
    backgroundColor: theme.palette.warning[16],
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 2,
    borderRadius: 4,
  },
  warningBadgeText: {
    color: theme.palette.warning.main,
    lineHeight: 1,
    fontWeight: 400,
  },
}));

export interface IStampProps {
  text?: string;
  type?: "primary" | "success" | "warning" | "fail" | "refunded";
}
